export default __webpack_public_path__ + "media/images/brands/lsa-3d3499f70d2eb1dc087fdf83a6f7f055.png";